import React from 'react';
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader
} from '@coreui/react';

export interface ConfirmationDialogProps {
  state: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  bodyTxt?: string;
  cancelButtonTxt?: string;
  confirmButtonTxt?: string;
}

const ConfirmationDialog = (props: ConfirmationDialogProps) => {
  const {
    state,
    onConfirm,
    onCancel,
    title,
    bodyTxt,
    cancelButtonTxt,
    confirmButtonTxt
  } = props;

  return (
    <CModal
      show={state}
      onClose={onCancel}
    >
      <CModalHeader closeButton>{title}</CModalHeader>
      <CModalBody>
        {bodyTxt}
      </CModalBody>
      <CModalFooter>
        <CButton
          color="primary"
          className="bg-color-orange border-0 roundedBtn"
          onClick={onConfirm}
        >{ confirmButtonTxt || 'Confirm'}</CButton>{' '}
        <CButton
          color="secondary"
          onClick={onCancel}
        >{ cancelButtonTxt || 'Cancel'}</CButton>
      </CModalFooter>
    </CModal>
  );
};

export default ConfirmationDialog;
